"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RequiredMark = exports.InputBaseHelperText = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var RequiredMark = _styledComponents["default"].span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tcolor: ", ";\n\tmargin: 0 6px;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.princetonOrange;
});
exports.RequiredMark = RequiredMark;
var InputBaseHelperText = _styledComponents["default"].p(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tfont-size: 0.625rem;\n\tword-break: break-word;\n\tmargin-top: 0.3rem;\n\tmin-height: 13px;\n\tcolor: ", ";\n"])), function (props) {
  return props.error ? props.theme.colors.princetonOrange : props.theme.colors.silver;
});
exports.InputBaseHelperText = InputBaseHelperText;